class User {
  constructor({ id, username, name, email, role, projects, is_active }) {
    this.id = id;
    this.email = email;
    this.username = username;
    this.name = name;
    this.role = role;
    this.projects = projects;
    this.is_active = is_active;
  }
}

export default User;
